<!-- 报表 销售退货单-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="退货日期：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable>
              <el-option v-for="item in projects" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="queryList">筛选</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="exportReturn">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="订单编号" prop="ORDER_CODE" min-width="100px"></el-table-column>
          <el-table-column label="退货日期" prop="RETURN_DATE" min-width="100px"></el-table-column>
          <el-table-column label="客户名称" prop="T_NAME" min-width="100px"></el-table-column>
          <el-table-column label="项目点" prop="P_NAME"></el-table-column>
          <el-table-column label="档口" prop="D_NAME"></el-table-column>
          <el-table-column label="操作时间" prop="OPERATION_TIME"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="openDetail(scope.row)" type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      inwareDate: [],
      name: '',
      pro_type: '',
      total_count: 0,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      form: {},
      pName: '',
      returnDialogVisible: false,
      region: '',
      deliverId: '',
      arr: [],
      searchForm: {},
      projects: [],
    };
  },
  methods: {
    // ----拉取项目点
    queryPro() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 15,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.projects = result.length > 0 ? result[0].project : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    posionFun() {
      this.pName = this.form.region;
    },
    // ------------------------拉取数据
    queryList() {
      this.$store.dispatch('SELLORDERRETURN_ALL', { PROJECT_ID: this.searchForm.PROJECT_ID, DAY_INTERVAL: this.searchForm.DAY_INTERVAL });
      const params = {
        SERVICE_ID: '10012',
        OTYPE: 7,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      http.post(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].ORDER_DATA;
            this.totalCount = result[0].TOTAL_COUNT;
          } else {
            this.tableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    exportReturn() {
      const params = {
        SERVICE_ID: '10012',
        OTYPE: 9,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      http.post(params)
        .then((result) => {
          if (result.length === 0) {
            this.$message.show({ text: '暂无数据', type: 'warning' });
          } else {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
    openDetail(row) {
      this.$router.push({ path: '/sellOrderReturnDetail/detail' });
      sessionStorage.setItem('RETURN_ID', row.ORDER_ID);
      sessionStorage.setItem('returnMess', JSON.stringify(row));
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.$set(this.searchForm, 'PROJECT_ID', this.$store.state.SELLORDERRETURN_ALL.PROJECT_ID);
    this.$set(this.searchForm, 'DAY_INTERVAL', this.$store.state.SELLORDERRETURN_ALL.DAY_INTERVAL);
    this.queryList();
    this.queryPro();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/sellOrderReturn.vue